import { IReleaseNote } from "../types"

export const RELEASE_1_4_3: IReleaseNote = {
    status: "PAST",
    title: "v1.4.3",
    date: "13th September 2024",
    releaseType: "Patch",
    notesBodyAllUsers: [
        {
            heading: "Introduction",
            content:
                "Patch 1.4.3 contains lots of small tweaks and improvements, all in response to feedback you have been submitting through the support portal and installer feedback form. It also includes a number of minor cosmetic changes to improve the user experience. Thank you to everyone who has submitted feedback!",
        },
    ],
    notesBodyInstaller: [
        {
            heading: "For installers using the web portal",
            content: "The following changes have been added:",
            bullets: [
                "We have added new helper text to the device search section of the application form. This text provides more information on how the search works, what filters it applies and provides some tips to help you find the device you are looking for. This is in response to feedback that some people are having issues locating their devices. We hope this will make the process easier for you.",
                "The reference to the support email inbox in the settings panel has been updated to a clickable malito link, meaning that when you click it, it will open your email client with the support email address pre-filled.",
                "We have added additional guidance to our tips and tricks for uploading a successful cut-out image - this updates the guidance to include a recommendation that the image be centred on the cut-out",
            ],
        },
        {
            heading: "For installers using our APIs",
            content: "The following changes have been added:",
            bullets: [
                "We have added additional detail to the metadata description of the field `supplyDetails.isNoIssues`. This detail warns developers to be careful to ensure that the field is set to `true` if there are no issues with the supply details. This warning is to ensure that the field is not accidentally set to `false` when there are no issues with the supply.",
                "We have improved clarity on the definitions of several fields in the LCT/TTR search API documentation. This includes: confirmation that 'DeviceRef' is analogous to the system reference; and, a description of how the TTR search '_id' parameters work - these parameters require searching on a backend database ID - you can use the ttr-reference API to return mappings of values to IDs.",
                "We have added some guidance on what values to input for the `supplyDetails.declaredVoltageAtConnect Point` field in the API documentation. Please note that at this stage this is only strongly recommended guidance - it is not enforced with validation",
            ],
        },
    ],
    notesBodyDno: [
        {
            heading: "For DNOs using the web portal",
            content: "The following changes have been added:",
            bullets: [
                "The email subject for the 'Further Information Required' email has been updated to remove a misleading reference to 'engineering works being required'. This suggestion was made by a DNO user who felt that the reference was misleading and could cause confusion, and was run past the DNO Delivery group prior to implementation",
                "The reference to the support email inbox in the settings panel has been updated to a clickable malito link, meaning that when you click it, it will open your email client with the support email address pre-filled.",
            ],
        },
        {
            heading: "For DNOs using our APIs",
            content: "The following change has been added:",
            bullets: [
                "We have improved clarity on the definitions of several fields in the LCT/TTR search protected API documentation. This includes: confirmation that 'DeviceRef' is analogous to the system reference; and, description of how the TTR search '_id' parameters work - these parameters require searching on a backend database ID - you can use the ttr-reference-protected API to return mappings of values to IDs.",
            ],
        },
    ],
    notesBodyManu: [
        {
            heading: "For manufacturers using the web portal",
            content: "The following change has been added:",
            bullets: [
                "The reference to the support email inbox in the settings panel has been updated to a clickable malito link, meaning that when you click it, it will open your email client with the support email address pre-filled.",
            ],
        },
    ],
    notesBodyDbAssessorDemand: [
        {
            heading: "For demand evaluators using the web portal",
            content: "The following change has been added:",
            bullets: [
                "The reference to the support email inbox in the settings panel has been updated to a clickable malito link, meaning that when you click it, it will open your email client with the support email address pre-filled.",
            ],
        },
    ],
    notesBodyDbAssessorGen: [
        {
            heading: "For generation evaluators using the web portal",
            content: "The following change has been added:",
            bullets: [
                "The reference to the support email inbox in the settings panel has been updated to a clickable malito link, meaning that when you click it, it will open your email client with the support email address pre-filled.",
            ],
        },
    ],
}
